import { type DocumentMeta } from "@prismicio/editor-fields"
import { request } from "@prismicio/editor-support/Http"
import { z } from "zod"

import { GenerateLandingPagesState } from "./GenerateLandingPagesState"
import type { LandingPagesApiClient } from "./LandingPagesApiClient"

export class ProductLandingPageApiClient implements LandingPagesApiClient {
  private baseUrl: URL
  private repository: string
  private credentials: RequestCredentials | undefined

  constructor({
    baseUrl,
    repository,
    credentials,
  }: {
    baseUrl: URL
    repository: string
    credentials: RequestCredentials | undefined
  }) {
    this.baseUrl = baseUrl
    this.repository = repository
    this.credentials = credentials
  }

  async startGenerateLandingPages(args: {
    document: DocumentMeta
    csv: string
  }): Promise<string> {
    const { document, csv } = args
    const { id } = document

    const url = new URL("landing-pages", this.baseUrl)
    url.searchParams.set("repository", this.repository)
    url.searchParams.set("baseDocumentId", id)

    const body = { csv }

    const response = await request(url, {
      method: "POST",
      body,
      credentials: this.credentials,
      okType: z.object({
        executionArn: z.string(),
      }),
    })

    return response.executionArn
  }

  async checkGenerateLandingPagesStatus(args: {
    executionArn: string
  }): Promise<GenerateLandingPagesState> {
    const { executionArn } = args

    const url = new URL("landing-pages", this.baseUrl)
    url.searchParams.set("executionArn", executionArn)

    const response = await request(url, {
      credentials: this.credentials,
      okType: GenerateLandingPagesState,
    })

    return response
  }
}
